export default __webpack_public_path__ + "static/diversity-5686bd5bc594ecde42e7b7f48c81e869.svg";